import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Button, Form, Card, Col, Row } from '_zari/core'

import {EstadosTablaComunConstant} from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

import * as FormGroups from './formGroups'
import { ValidationSchema } from './validation'

const CrearEditarPlantillaSection = ({ editarData, refrescarTabla, refrescarSection, tipo }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      tipo: tipo,
      codigo: editarData.codigo || '',
      nombre: editarData.nombre || '',
      estado: EstadosTablaComunConstant.HABILITADO
    }
  }, [tipo, editarData])

  const submitHandler = React.useCallback(
    data => {
      const promiseAction = editarData._id
        ? () => TablaComunService.actualizarxId(editarData._id, data)
        : () => TablaComunService.nuevo(data)

      promiseAction()
        .then(() => {
          __zariContext.toast(
            'success',
            editarData._id ? 'La plantilla se ha actualizado.' : 'La plantilla se ha creado.'
          )
          refrescarTabla()
          refrescarSection()
        })
        .catch(({ data: { error } }) => __zariContext.toast('error', error))
    },
    [__zariContext, editarData, refrescarTabla, refrescarSection]
  )

  return (
    <Card>
      <Card.Header>{editarData._id ? 'Editar Plantilla' : 'Nuevo Plantilla'}</Card.Header>
      <Card.Body>
        <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
          {({ errors, handleSubmit, isSubmitting, setFieldValue, touched, values }) => (
            <Form>
              <FormGroups.CodigoFormGroup
                iError={errors.codigo}
                iTouched={touched.codigo}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
              <Row className='mt-2'>
                <Col md={12} className='text-right'>
                  <Button color='secondary' onClick={refrescarSection}>
                    Cancelar
                  </Button>
                  <Button onClick={handleSubmit}>{editarData._id ? 'Actualizar' : 'Crear'}</Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  )
}

export default React.memo(CrearEditarPlantillaSection)
